import { getFieldErrors, isApiError, readApiError } from '@/services/api';

type NoteField = 'noteType' | 'body' | 'crmCaseId';

const WIRE_TO_FORM_FIELD: Record<string, NoteField> = {
    note_type: 'noteType',
    body: 'body',
    crm_case_id: 'crmCaseId',
};

const FALLBACK_MESSAGE = 'Failed to save the note. Please try again.';

export interface NoteSubmitError {
    fieldErrors: { field: NoteField; message: string }[];
    message: string | null;
}

export function mapNoteSubmitError(error: unknown): NoteSubmitError {
    const wireErrors = getFieldErrors(error);
    const fieldErrors = Object.entries(wireErrors).flatMap(([wireField, messages]) => {
        const field = WIRE_TO_FORM_FIELD[wireField];
        return field && messages[0] ? [{ field, message: messages[0] }] : [];
    });
    const hasUnmappedErrors = Object.keys(wireErrors).some((wireField) => !WIRE_TO_FORM_FIELD[wireField]);

    if (fieldErrors.length > 0 && !hasUnmappedErrors) {
        return { fieldErrors, message: null };
    }

    const message = isApiError(error) && error.data ? readApiError(error.data).message : FALLBACK_MESSAGE;
    return { fieldErrors, message };
}
